<div class="kt-footer  kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop" id="kt_footer">
    <div class="kt-container  kt-container--fluid ">
        <div class="kt-footer__copyright">
            2021&nbsp;&copy;&nbsp;<a href="http://ofera.com.mx/" target="_blank" class="kt-link">Ofera</a>
        </div>
    </div>
</div>